
define('text!modules/news_form/news_form_template.html',[],function () { return '<form class="news-form large-form">\r\n\r\n  <div class="js-feedback"></div>\r\n\r\n  <div class="js-form-sections"></div>\r\n\r\n  <div class="form-buttons">\r\n    <button type="submit" class="button button-primary"><%- _.t(\'newsform.button.save\') %></button>\r\n  </div>\r\n</form>\r\n';});

